export default __webpack_public_path__ + "static/media/backIcon.a98fc1f3.svg";